module.exports = __webpack_public_path__ + "static/media/file-blue.77162720.svg";